import React, { Component } from 'react'
import JewelryPanel from '../jewelry-panel'
import Spacer from '../../../components/spacer'
import SelectItem from '../../../components/select-item'
import { jewelryTypeIsRing } from '../../../utils/jewelry-validation'

class ShankSideDiamondPanel extends Component {
  render () {
    const props = this.props

    return (
      <JewelryPanel
        id='shankSideDiamondPanelContainer'
        show={jewelryTypeIsRing(props)}
        isResetting={props.isResetting}>

        <Spacer lg />

        <SelectItem
          id='diamonds_on_outside_sides_of_shank'
          label='Diamonds on Outside Sides of Shank?'
          labelId='shanksides'
          options={[
            {value: false, label: 'No'},
            {value: true, label: 'Yes'}
          ]}
          value={props.diamonds_on_outside_sides_of_shank}
          onChange={props.onChangeVal.bind(this, 'diamonds_on_outside_sides_of_shank')}
        />

        <JewelryPanel
          id='shankSideDiamondPanel'
          show={props.diamonds_on_outside_sides_of_shank}
          isResetting={props.isResetting}>

          <Spacer xxs />

          <SelectItem
            id='distance_diamonds_down_sides_of_shank'
            label='Distance of Diamonds on Outside Sides of Shank'
            labelId='distance_diamonds_down_sides_of_shank'
            options={[
              {value: 0.25, label: '1/4'},
              {value: 0.5, label: '1/2+1'},
              {value: 0.75, label: '3/4'},
              {value: 1.00, label: 'Eternity'}
            ]}
            value={props.distance_diamonds_down_sides_of_shank}
            onChange={props.onChangeVal.bind(this, 'distance_diamonds_down_sides_of_shank')}
            initVal={null}
          />

          <Spacer xxs />

          <SelectItem
            label='Quality of Diamonds on Outside Sides of Shank'
            id='shankSideDiamondQuality'
            labelId='quality_of_diamonds_down_sides_of_shank'
            options={[
              {value: 'standard', label: 'Standard'},
              {value: 'plus', label: 'Plus'},
              {value: 'lab_grown', label: 'Lab Grown'},
            ]}
            value={props.quality_of_diamonds_down_sides_of_shank}
            onChange={props.onChangeVal.bind(this, 'quality_of_diamonds_down_sides_of_shank')}
            initVal={null}
          />

          <Spacer xxs />

          <SelectItem
            id='setting_style_of_diamonds_down_sides_of_shank'
            label='Setting Style of Diamonds on Outside Sides of Shank'
            labelId='setting_style_of_diamonds_down_sides_of_shank'
            options={[
              {value: 'pave_border', label: 'Pavé w/ Border'},
              {value: 'channel_set', label: 'Channel Set'}
            ]}
            value={props.setting_style_of_diamonds_down_sides_of_shank}
            onChange={props.onChangeVal.bind(this, 'setting_style_of_diamonds_down_sides_of_shank')}
            initVal={null}
          />

          <Spacer xxs />

          <SelectItem
            id='milgrain_sides_of_shank'
            label='Milgrain on Outside Sides of Shank'
            labelId='milgrain_sides_of_shank'
            options={[
              {value: 'no', label: 'No'},
              {value: 'yes', label: 'Yes'}
            ]}
            value={props.milgrain_sides_of_shank}
            onChange={props.onChangeVal.bind(this, 'milgrain_sides_of_shank')}
            initVal={null}
          />
        </JewelryPanel>
      </JewelryPanel>
    )
  }
}

export default ShankSideDiamondPanel



// WEBPACK FOOTER //
// ./src/components/jewelry-search-filters/shank-side-diamond-panel/index.js